export const PRINT_FIELD_DEFINITIONS = [
  { key: "risk_name", label: "Risk name", section: "header" },
  { key: "risk_id", label: "Risk ID", section: "header" },
  { key: "description", label: "Description", section: "detail" },
  { key: "owner", label: "Owner", section: "summary" },
  { key: "status", label: "Status", section: "header" },
  { key: "category", label: "Category", section: "summary" },
  { key: "inherent_score", label: "Inherent score", section: "summary" },
  { key: "residual_score", label: "Residual score", section: "summary" },
  { key: "risk_matrix", label: "Risk matrix", section: "matrix" },
  { key: "control_effectiveness", label: "Control effectiveness", section: "summary" },
  { key: "trend", label: "Trend", section: "summary" },
  { key: "latest_note", label: "Latest note", section: "detail" },
  { key: "last_updated", label: "Last updated", section: "summary" },
  { key: "review_date", label: "Review date", section: "summary" },
  { key: "linked_controls", label: "Linked controls", section: "list" },
  { key: "linked_actions", label: "Linked actions / treatment plans", section: "list" },
  { key: "tags", label: "Tags", section: "tag" },
];

export const DEFAULT_PRINT_FIELD_KEYS = [
  "risk_name",
  "owner",
  "status",
  "inherent_score",
  "residual_score",
  "latest_note",
  "last_updated",
];

export const PRINT_FIELD_MAP = PRINT_FIELD_DEFINITIONS.reduce((acc, field) => {
  acc[field.key] = field;
  return acc;
}, {});

export const PRINT_SUB_OPTION_DEFINITIONS = [
  {
    key: "linked_controls_summary",
    parentKey: "linked_controls",
    label: "Show control summary buttons",
  },
  {
    key: "linked_actions_summary",
    parentKey: "linked_actions",
    label: "Show action summary buttons",
  },
];

export const DEFAULT_PRINT_SUB_OPTIONS = {
  linked_controls_summary: false,
  linked_actions_summary: false,
};
